export default function TeacherAchievementsSection({ achievements }) {
  return (
    <section className="bg-gradient-to-r from-[#002B80] to-[#0076C0] px-4 py-12 sm:px-6 lg:px-8 lg:py-14">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-2xl font-bold text-white sm:text-[32px]">Key Achievement</h2>
        <ul className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:gap-x-16 lg:gap-y-6">
          {achievements.map((item, index) => (
            <li key={`${item}-${index}`} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#69991D]">
                <svg className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span className="text-sm font-medium leading-relaxed text-white sm:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
